<template>
  <div class="hs-accordion-group" :class="compacto ? 'space-y-3' : 'mt-10'">
    <SimpleSkeleton v-if="loading" :options="getSkeleton(1, 10)" />
    <template v-else>
      <div
        v-for="(categoria, indice) in categorias"
        :id="`${prefijoId}_${indice}`"
        :key="categoria"
        class="hs-accordion --prevent-on-load-init border bg-white dark:border-neutral-700 dark:bg-neutral-800"
        :class="[
          { active: indice === expanded },
          compacto
            ? 'rounded-xl border-gray-200'
            : '-mt-px border-gray-400 first:rounded-t-lg last:rounded-b-lg'
        ]"
      >
        <h2>
          <button
            :id="`${prefijoId}_TOGGLE_${indice}`"
            type="button"
            class="hs-accordion-toggle flex min-h-14 w-full scroll-mt-24 items-center gap-3 rounded-[inherit] px-5 py-4 text-start font-semibold text-gray-800 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-600 focus-visible:ring-inset dark:text-neutral-100 dark:hover:bg-neutral-700 dark:focus-visible:ring-blue-400"
            :aria-expanded="indice === expanded"
            :aria-controls="`${prefijoId}_BODY_${indice}`"
            @click="expand(indice, $event)"
          >
            <MinusIcon
              v-if="indice === expanded"
              class="size-4 shrink-0 text-blue-700 dark:text-blue-300"
              aria-hidden="true"
            />
            <PlusIcon v-else class="size-4 shrink-0" aria-hidden="true" />
            <slot
              name="encabezado"
              :cat="categoria"
              :i="indice"
              :expanded="expanded"
            >
              {{ categoria }}
            </slot>
          </button>
        </h2>
        <slot
          name="items"
          :cat="categoria"
          :categorias="categorias"
          :expanded="expanded"
          :i="indice"
          v-bind="{
            idContenido: `${prefijoId}_BODY_${indice}`,
            idEncabezado: `${prefijoId}_TOGGLE_${indice}`
          }"
        >
          <div
            v-if="bodys"
            v-show="indice === expanded"
            :id="`${prefijoId}_BODY_${indice}`"
            class="hs-accordion-content w-full"
            role="region"
            :aria-labelledby="`${prefijoId}_TOGGLE_${indice}`"
          >
            <div class="px-5 pb-4">{{ bodys[indice] }}</div>
          </div>
        </slot>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue'
import { MinusIcon, PlusIcon } from '@heroicons/vue/24/outline'
import { getSkeleton } from '@/modules/Core/usings/generales'

withDefaults(
  defineProps<{
    categorias: string[]
    loading: boolean
    bodys?: string[]
    prefijoId?: string
    compacto?: boolean
  }>(),
  { bodys: undefined, prefijoId: 'CATEG', compacto: false }
)
const expanded = ref(0)

const expand = async (indice: number, evento: MouseEvent) => {
  const encabezado = evento.currentTarget as HTMLButtonElement
  expanded.value = expanded.value === indice ? -1 : indice
  await nextTick()
  if (expanded.value === indice && encabezado.getBoundingClientRect().top < 0) {
    encabezado.scrollIntoView({ block: 'start', behavior: 'instant' })
  }
}
</script>
